import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu",
  "use": "icon-menu-usage",
  "viewBox": "0 0 220 220",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 220 220\" id=\"icon-menu\"><path d=\"M43.36,62.79H176.64a4.5,4.5,0,0,0,0-9H43.36a4.5,4.5,0,0,0,0,9Z\" /><path d=\"M43.36,166.21H176.64a4.5,4.5,0,0,0,0-9H43.36a4.5,4.5,0,1,0,0,9Z\" /><path d=\"M43.36,114.5h85.4a4.5,4.5,0,0,0,0-9H43.36a4.5,4.5,0,0,0,0,9Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol